var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AufgabenWidget',{attrs:{"filter":_vm.params.filter,"aufgaben":_vm.params.data.aufgaben,"ansicht":_vm.params.ansicht,"onPlusSignClicked":_vm.params.onPlusSignClicked,"data":_vm.params.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }